import { Shark, Utils, View } from "shark-mvc";

import templateContent from "./construction-site-card-edit.html";

import { clientManager } from "../../_shark_jaws/managers/clientManager";
import constructionSiteCardListView from "./constructionSiteCardListView";
import { constructionSiteCardManager } from "../../_shark_jaws/managers/constructionSiteCardManager";
import contactDetailsModalComponent from "../../components/contactDetailsModal/contactDetailsModalComponent";
import { documentManager } from "../../_shark_jaws/managers/documentManager";
import { exportPDFComponent } from "../../_shark_components/exportPDF/exportPDFComponent";
import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import printButtonComponent from "../../_shark_components/printButton/printButtonComponent";
import { quotationManager } from "../../_shark_jaws/managers/quotationManager";
import { siteInfoSheetManager } from "../../_shark_jaws/managers/siteInfoSheetManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";

class ConstructionSiteCardEditView extends View {
	constructor () {
		super("constructionSiteCardEditView");
		this.setTemplate(templateContent);
	}

	beforeLoad () {
		window.scrollTo(0, 0);
		const currUser = Shark.get("currUser");
		let currConstructionSiteCard = Shark.get("currConstructionSiteCard");

		if (currConstructionSiteCard) {
			waitBoxComponent.open();
			//clientManager.getListByAgent({guid: currConstructionSiteCard.userGuid}, true);

			if (currConstructionSiteCard.guid.trim() !== "") {
				constructionSiteCardManager.getByGuid(currConstructionSiteCard.guid, currConstructionSiteCard)
				.then(getByGuidResponse => {
					console.log({getByGuidResponse});
					documentManager.getByGuidList2(currConstructionSiteCard.attachmentsGuids)
					.then(getDocumentListResponse => {
						currConstructionSiteCard.matchAttachmentsWithDocuments(getDocumentListResponse.data);
						waitBoxComponent.close();
						Shark.render();
					});
				});
			}
			else {
				documentManager.getByGuidList2(currConstructionSiteCard.attachmentsGuids)
				.then(getDocumentListResponse => {
					currConstructionSiteCard.matchAttachmentsWithDocuments(getDocumentListResponse.data);
					waitBoxComponent.close();
					Shark.render();
				});
			}

			//contactDetailsModalComponent.set("referenceDocument", currConstructionSiteCard);
			this.set({
				__editEnabled: false,
			});

			exportPDFComponent.set("documentSaveName", "Scheda Cantiere - " + currConstructionSiteCard.registry.clientName + " - " + currConstructionSiteCard.__siteLocationLabel);
			exportPDFComponent.set("documentToExport", currConstructionSiteCard);
		}
	}



	
	actualWallSupportNature06_changeHandler () {
		if (Shark.get("#actualWallSupportNature06").prop("checked")) {
			Shark.get("#actualWallSupportNaturesHumidityPercentBox").show();
		}
		else {
			Shark.get("#actualWallSupportNaturesHumidityPercentBox").hide();
		}
	}

	afterRender () {
		let currConstructionSiteCard = Shark.get("currConstructionSiteCard");
		if (!currConstructionSiteCard) {
			Shark.openPage(constructionSiteCardListView);
			return;
		}

		console.log({isEditing: this.get("isEditing")})
		if (this.get("isEditing")) {
			//Dave: Ti prego, facciamone una funzione
			const inputList = document.querySelectorAll("input");
			inputList.forEach(item => {
				item.disabled = false;
				item.readOnly = false;
				item.classList.remove("form-control-plaintext", "col-form-value");
				item.classList.add("form-control");
			});
			
			const selectList = document.querySelectorAll("select");
			selectList.forEach(item => {
				item.disabled = false;
				item.readOnly = false;
				item.classList.remove("form-control-plaintext", "col-form-value");
				item.classList.add("form-control");
			});
			
			const textareaList = document.querySelectorAll("textarea");
			textareaList.forEach(item => {
				item.disabled = false;
				item.readOnly = false;
				item.classList.remove("form-control-plaintext", "col-form-value");
				item.classList.add("form-control");
			});

			const removePremiseDestinationBtns = document.querySelectorAll(".removePremiseDestinationBtn");
			removePremiseDestinationBtns.forEach(item => {
				item.classList.remove("d-none");
			});
		}
	}

	backToListBtn_clickHandler () {
		const currConstructionSiteCard = Shark.get("currConstructionSiteCard");

		if (!currConstructionSiteCard.isDirty() || (currConstructionSiteCard.isDirty() && confirm("Sei sicuro di voler annullare? I dati già inseriti saranno persi."))) {
			Shark.openPage(constructionSiteCardListView);
		}
	}

	beforeRender () {
		this.set({
			__nextPictureSaveName: Shark.__generateGUID(),
			__nextSignageSaveName: Shark.__generateGUID(),
		});
	}

	cancelEditsBtn_clickHandler () {
		const currConstructionSiteCard = Shark.get("currConstructionSiteCard");

		if (!currConstructionSiteCard.isDirty() || (currConstructionSiteCard.isDirty() && confirm("Sei sicuro di voler annullare? I dati già inseriti saranno persi."))) {
			Shark.set("currConstructionSiteCard", null);
			
			const cancelDestination = this.get("cancelDestination");
			if (cancelDestination) {
				this.set("cancelDestination", null);
				Shark.openPage(cancelDestination);
			}
			else {
				Shark.openPage(constructionSiteCardListView);
			}
		}
	}

	init () {
		this.addComponents([contactDetailsModalComponent, exportPDFComponent, mainNavComponent, printButtonComponent, waitBoxComponent]);
	}

	saveItemBtn_clickHandler () {
		const currConstructionSiteCard = Shark.get("currConstructionSiteCard");
		const validationErrors = currConstructionSiteCard.validate();

		if (validationErrors.length > 0) {
			alert("Attenzione, si sono verificati i seguenti errori:\n\n" + validationErrors.join("\n"));
			Shark.render();
		}
		else {
			this.set("afterSaveDestination", null);

			this.set({
				__saving: true
			});
			this.render();
			console.log(currConstructionSiteCard);

			constructionSiteCardManager.save(currConstructionSiteCard)
			.then(saveResponse => {
				console.log({saveResponse});

				quotationManager.setConstructionSiteCard({
					guid: saveResponse.data.extraData.quotationGuid,
					constructionSiteCardGuid: saveResponse.data.guid
				})
				.then(setResponse => {
					console.log({setResponse});
				});
			});
		}
	}

	removePremiseDestinationBtn_clickHandler (event, data) {
		if (confirm("Confermi di voler rimuovere quest'area di utilizzo dalla Scheda Cantiere?\n\nEra prevista nel Preventivo, e se la rimuovi non potrai recuperarla.")) {
			const currConstructionSiteCard = Shark.get("currConstructionSiteCard");
			const premiseIndex = data.index;
			
			currConstructionSiteCard.systems.splice(premiseIndex, 1);
			currConstructionSiteCard.set("extraData.systemsChanged", true);
			siteInfoSheetManager.reindexSystem(currConstructionSiteCard);
			
			Shark.render();
		}
	}

	sitePremiseScopeSelect_changeHandler () {
		const sitePremiseScopeSelect = document.querySelector("#sitePremiseScopeSelect");

		if (sitePremiseScopeSelect) {
			const currConstructionSiteCard = Shark.get("currConstructionSiteCard");
			currConstructionSiteCard.registry.sitePremiseDestinations = [];

			switch (sitePremiseScopeSelect.value) {
				case "private":
					document.querySelector("#sitePremiseScopePrivates").classList.remove("d-none");
					document.querySelector("#sitePremiseScopePublics").classList.add("d-none");
					document.querySelectorAll("#sitePremiseScopePublics input").forEach(item => item.checked = false);
					break;
				case "public":
					document.querySelector("#sitePremiseScopePrivates").classList.add("d-none");
					document.querySelector("#sitePremiseScopePublics").classList.remove("d-none");
					document.querySelectorAll("#sitePremiseScopePrivates input").forEach(item => item.checked = false);
					break;
			}
		}
	}

	// uploadedImage_changeHandler (event) {
	// 	waitBoxComponent.show();

	// 	constructionSiteCardManager.uploadPicture(event.target)
	// 	.then(uploadResponse => {
	// 		waitBoxComponent.hide();
	// 		Shark.render();
	// 	});
	// });

	// uploadPictureBtn_clickHandler (event) {
	// 	document.querySelector("#uploadedImage").click();
	// });

	uploadSignageProjectField_changeHandler (event) {
		alert("Mi spiace, questa funzionalità non è ancora disponibile.\n\nSegnala il problema 'CSC-D-240'");
		// constructionSiteCardManager.uploadPicture(event.target)
		// .then(uploadResponse => {
		// 	Shark.render();
		// });
	}

	uploadSignageProjectBtn_clickHandler (event) {
		document.querySelector("#uploadSignageProjectField").click();
	}

	jointsNeededForPresentCracksChk_changeHandler () {
		const jointsNeededForPresentCracksAlert = document.querySelector("#jointsNeededForPresentCracksAlert");
		const jointsNeededForPresentCracksChk = document.querySelector("#jointsNeededForPresentCracksChk");

		if (jointsNeededForPresentCracksAlert && jointsNeededForPresentCracksChk) {
			if (jointsNeededForPresentCracksChk.checked) {
				jointsNeededForPresentCracksAlert.classList.remove("d-none");
			}
			else {
				jointsNeededForPresentCracksAlert.classList.add("d-none");
			}
		}
	}
}

const constructionSiteCardEditView = new ConstructionSiteCardEditView();


Shark.registerView(constructionSiteCardEditView);

export default constructionSiteCardEditView;
